export const encodeQueryData = (params: any): string => {
    // for java server, send array value like that : value=toto&value=tata
    const queryParams: string[] = []

    Object.keys(params).forEach((param) => {
        // debugger;
        if (Array.isArray(params[param])) {
            params[param].forEach((value: string) => {
                if (param === 'validatorNames' && value === '' && params[param].length === 1) {
                    queryParams.push(`${encodeURIComponent(param)}=${encodeURIComponent('novalidator')}`)
                } else {
                    queryParams.push(`${encodeURIComponent(param)}=${encodeURIComponent(value)}`)
                }
            })
        } else {
            queryParams.push(`${encodeURIComponent(param)}=${encodeURIComponent(params[param])}`)
        }
    })

    return queryParams.length > 0 ? `?${queryParams.join('&')}` : ''
}
